'use client';

import React from 'react';
import { Star } from 'lucide-react';

/* --- INTERNAL COMPONENT --- */
function MarqueeStripe({
  text,
  bgColor = 'bg-transparent',
  textColor = 'text-gray-500',
  speed = 20,
  reverse = false,
  className = '',
}) {
  const words = Array(5).fill(text);

  const style = `
    @keyframes marquee {
      0% { transform: translateX(0%); }
      100% { transform: translateX(-50%); }
    }
  `;

  return (
    <>
      <style>{style}</style>
      <div
        className={`w-full py-1 md:py-2 ${bgColor} ${textColor} overflow-hidden ${className}`} 
        style={{ animationDirection: reverse ? 'reverse' : 'normal' }}
      >
        <div
          className="flex whitespace-nowrap"
          style={{
            animation: `marquee ${speed}s linear infinite`,
            animationDirection: reverse ? 'reverse' : 'normal',
            width: '200%',
          }}
        >
          {words.map((word, i) => (
            <div key={i} className="flex items-center mx-4 md:mx-12">
              <Star className="w-3 h-3 md:w-5 md:h-5 mx-2 md:mx-6" fill="currentColor" />
              <span className="text-lg md:text-3xl font-black uppercase tracking-widest">{word}</span>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

/* --- MAIN EXPORT --- */
export default function MarqueeSection() {
  const marqueeText = "SCULPT ♦ DEFINE ♦ RECOVER ♦ TRANSFORM ♦ STRENGTH";

  return (
    // UPDATED HEIGHT HERE: h-[150px] md:h-[300px]
    <section className="relative w-full my-0 py-0 bg-black overflow-hidden h-[150px] md:h-[300px] flex items-center justify-center">
      <div className="relative w-full max-w-[1200px] h-full flex items-center justify-center">
        {/* Background Stripe */}
        <MarqueeStripe
          text={marqueeText}
          textColor="text-gray-800"
          speed={40}
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 transform -rotate-12 md:-rotate-6 z-10 w-[200%] md:w-[120%]" 
        />

        {/* Center Highlight Stripe */}
        <MarqueeStripe
          text={marqueeText}
          bgColor="bg-[#faaf40]" 
          textColor="text-black"
          speed={30}
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-20 w-[200%] md:w-[120%]" 
        />

        {/* Foreground Stripe */}
        <MarqueeStripe
          text={marqueeText}
          textColor="text-gray-800"
          speed={40}
          reverse={true} 
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 transform rotate-12 md:rotate-6 z-10 w-[200%] md:w-[120%]" 
        />
      </div>
    </section>
  );
}